import PropTypes from "prop-types";

import MDBadge from "components/MDBadge";

// Active / inactive status pill used in entity table rows.
function StatusBadge({ active, activeLabel, inactiveLabel }) {
  return (
    <MDBadge
      badgeContent={active ? activeLabel : inactiveLabel}
      color={active ? "success" : "error"}
      variant="gradient"
      size="sm"
      container
    />
  );
}

StatusBadge.defaultProps = {
  active: false,
  activeLabel: "Active",
  inactiveLabel: "Inactive",
};

StatusBadge.propTypes = {
  active: PropTypes.bool,
  activeLabel: PropTypes.string,
  inactiveLabel: PropTypes.string,
};

export default StatusBadge;
